/**
 * SettingsRedirect — Canonical redirect from legacy settings routes
 * (e.g. `/sessions/settings`, `/email/settings`) to the unified settings
 * page at `/settings` (registered automatically by createShell() via
 * `config.settings`).
 *
 * This component was duplicated verbatim across ~10 app shells. Promoting
 * it here as the single source of truth eliminates the copies.
 *
 * Plan: dashboard_shared_infra_consolidation_plan_2026-06-23 Phase 2.
 *
 * Preserves the incoming `?query` and `#hash` (e.g. `/sessions/settings?tab=voice`
 * → `/settings?tab=voice`) via LegacyRedirect — a bare `<Navigate>` dropped them
 * (ai visual QA, 2026-10-12).
 *
 * @layer routing
 * @package @plerity/dashboard-shell
 */

import { LegacyRedirect } from "./LegacyRedirect";

export function SettingsRedirect() {
  return <LegacyRedirect to="/settings" />;
}

export default SettingsRedirect;
